// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2gq7U","col":"styles_col__3ghd-","fulfillmentStatus":"styles_fulfillmentStatus__3x83e","emailCol":"styles_emailCol__24V1A"};